import { formatPrice } from "./currency";

// Currency (business "Currency" setting) and number conventions (UI language) both live in
// src/utils/currency.ts; this stays as the long-standing entry point for existing callers.
export default function PriceFormat(price) {
  return formatPrice(price);
}
